export var buildEnv = {
    buildMode: 'release',
    datacenter: 'us',
    sdkVersion: '1.25.4',
};
//# sourceMappingURL=buildEnv.js.map